import { IkhlasVerseCard } from './IkhlasVerseCard';
import './IkhlasFullBlock.css';

export function IkhlasFullBlock() {
  return (
    <section className="wi-home-ikhlas-block" aria-label="Surah Al-Ikhlas and 99 names of Allah">
      <IkhlasVerseCard />
    </section>
  );
}

